import { AiToneAndVoiceSettingsSchemaRaw } from "@redotech/redo-concierge-settings-common/ai-tone-and-voice";
import * as z from "zod";

const initializeAiToneAndVoiceInput = z.object({});

const initializeAiToneAndVoiceOutput = z.object({
  initialized: z.boolean(),
  settings: AiToneAndVoiceSettingsSchemaRaw.optional(),
});

export const initializeAiToneAndVoice: {
  name: "initializeAiToneAndVoice";
  input: typeof initializeAiToneAndVoiceInput;
  output: typeof initializeAiToneAndVoiceOutput;
} = {
  name: "initializeAiToneAndVoice" as const,
  input: initializeAiToneAndVoiceInput,
  output: initializeAiToneAndVoiceOutput,
};
